function generateKey(length: number) {
    var key = "";
  
    // Generate random bytes using the window.crypto API
    var randomBytes = window.crypto.getRandomValues(new Uint8Array(length));
  
    // Convert the random bytes to a string of alphanumeric characters
    for (var i = 0; i < randomBytes.length; i++) {
      key += _getPossibleCharacter(randomBytes[i]);
    }
  
    return key;
}
  
function _getPossibleCharacter(code: number) {
    // Define the possible alphanumeric characters and special characters
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!#$%&'()*+,-./:;<=>?@[\]^_`{|}~";
  
    return possible.charAt(code % possible.length);
}

function xor(str: string, key: string) {
    let result = ''
    for (let i = 0; i < str.length; i++) {
        let code = str.charCodeAt(i)
        code ^= key.charCodeAt(i % key.length)
        result += String.fromCharCode(code)
    }
    return result
}

export {
    generateKey,
    xor
}